import { Injectable } from '@angular/core';
import {
  HttpClient,
} from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

@Injectable({
  providedIn: 'root',
})
export class CertificadosService {
  private readonly apiUrl = `${environment.HOST}${URL_MAP.API.CERTIFICADOS_RETENCIONES}`;

  constructor(private httpClient: HttpClient) {}

  descargarCertificado(tipo: string, request: any) {
    return this.httpClient.post(
      `${this.apiUrl}/pdf/${tipo}`,
      request, 
      {
        responseType: 'blob',
        observe: 'response',
      },
    );
  }
}
